<template>
  <Container>
    <Spinner>
      <Ball />
      <Ball />
      <Ball />
    </Spinner>
  </Container>
</template>

<script>
import { Container, Spinner, Ball } from './loader.styles';

export default {
  components: { Container, Spinner, Ball },
};
</script>
